module.exports = __webpack_public_path__ + "static/media/chat04.bdc8902b.gif";